import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Pages/Home/HomeScreen';

function App() {
  return (
    <div className="App">
      <Router>
        <div>
            <Routes>
              <Route path='/' Component={Home}/>
              <Route path='*' element={<div>404 Not Found</div>}/>
            </Routes>
          </div>
      </Router>
    </div>
  );
}

export default App;
